/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardItem_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/loyaltyCardItems/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/loyaltyCardItems/deleted'}
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardItem',["LoyaltyCardItem_Resource","LoyaltyCardItemData", "CustomerData","LoyaltyCardData","HumanResourceData","SaleData","TaxMode","SaleItem","LoyaltyCardCategory","LoyaltyCard",
        function (LoyaltyCardItem_Resource,LoyaltyCardItemData,CustomerData,LoyaltyCardData,HumanResourceData,SaleData,TaxMode,SaleItem,LoyaltyCardCategory,LoyaltyCard)
    {

        var LoyaltyCardItem = function (resource, isSaleAdvanceLoading)
        {
            SaleItem.call(this);

            this.id = null;
            this.isDeleted=false;
            this.label = "";
            this.color = "";
            this.type = null;
            this.itemType = null;
            this.ptsByCa = 0;
            this.ptsBySale = 0;
            this.monthValidity= null;
            this.validityExtend= null;
            this.validityDate = null;
            this.alertExp =0;
            this.description= "";
            this.price= null;
            this.vat = null;
            this.vatCode = null;
            this.originalPrice= null;
            this.discountPercent= null;
            this.pts= null;
            this.sale =null;
            this._saleId= null;
            this.humanResource = null;
            this._humanResourceId= null;
            this.customer = null;
            this._customerId= null;
            this.loyaltyCard = null;
            this._loyaltyCardId= null;
            this.goalPts = null;
            this.goalType = null;
            this.goalAmount = null;
            this.goalText = null;
            this.isUsed = null;
            this.version = null;
            if (resource !== undefined && resource != null) {
                this.loadObject(resource);
            }
            if (isSaleAdvanceLoading === undefined || !isSaleAdvanceLoading) {
                LoyaltyCardItemData.add(this);
            }
        }

        LoyaltyCardItem.prototype = Object.create(SaleItem.prototype);//inherit functions from SaleItem

        LoyaltyCardItem.prototype.loadObject = function(object)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.color = object.color;
            this.type = object.type;
            this.itemType = object.itemType;
            this.ptsByCa = object.ptsByCa;
            this.ptsBySale = object.ptsBySale;
            this.monthValidity = object.monthValidity;
            this.validityExtend = object.validityExtend;
            this.alertExp = object.alertExp;
            if (object.validityDate)
                this.validityDate = new Date(object.validityDate);
            this.description= object.description;
            this.price= object.price;
            this.vat=object.vat;
            this.vatCode=object.vatCode;
            this.originalPrice= object.originalPrice;
            this.discountPercent= object.discountPercent;
            this.pts= object.pts;
            this._saleId=object.saleId;
            this._humanResourceId=object.humanResourceId;
            this._customerId=object.customerId;
            this._loyaltyCardId=object.loyaltyCardId;
            this.goalPts = object.goalPts;
            this.goalType = object.goalType;
            this.goalAmount = object.goalAmount;
            this.goalText = object.goalText;
            this.isUsed = object.isUsed;
            if (object.version)
                this.version = object.version;

        };
        LoyaltyCardItem.prototype.getObjectResource = function()
        {
            var res = new LoyaltyCardItem_Resource();
            res.id = this.id;
            res.isDeleted = this.isDeleted;
            res.color =this.color;
            res.label =this.label;
            res.type =this.type;
            res.itemType =this.itemType;
            res.ptsByCa =this.ptsByCa;
            res.ptsBySale =this.ptsBySale;
            res.monthValidity =this.monthValidity;
            res.validityExtend =this.validityExtend;
            res.alertExp =this.alertExp;
            res.validityDate =this.validityDate;
            res.description = this.description ;
            res.price= this.price;
            res.vat=this.vat;
            res.vatCode=this.vatCode;
            res.originalPrice= this.originalPrice;
            res.discountPercent= this.discountPercent;
            res.pts= this.pts;
            if (this.sale)
                res.saleId = this.sale.id;
            else
                res.saleId = null;
            if (this.customer)
                res.customerId = this.customer.id;
            else
                res.customerId = null;
            if (this.humanResource)
                res.humanResourceId = this.humanResource.id;
            else
                res.humanResourceId = null;
            if (this.loyaltyCard)
                res.loyaltyCardId = this.loyaltyCard.id;
            else
                res.loyaltyCardId = null;

            res.goalPts = this.goalPts;
            res.goalType = this.goalType;
            res.goalAmount = this.goalAmount;
            res.goalText = this.goalText;
            res.isUsed = this.isUsed;
            return res;
        };

        LoyaltyCardItem.prototype.loadRef =  function(isPreviousVersion, isApplicationLoading)
        {
            if (this._customerId)
                this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
            if (this._loyaltyCardId)
                this.loyaltyCard = LoyaltyCardData.getById(this._loyaltyCardId);
            if (this._humanResourceId)
                this.humanResource = HumanResourceData.getById(this._humanResourceId);
            if (this._saleId)
                this.sale = SaleData.getById(this._saleId, isApplicationLoading);

        };

        LoyaltyCardItem.prototype.reload = function(endFunction)
        {
            var loyaltyCardSrv = this.getObjectResource();
            var loyaltyCard = this;
            if (this.getId()!=null)
                loyaltyCardSrv.$get({id:this.getId()}, //params
                    function (data) {   //success
                        loyaltyCard.loadObject(data);
                        if (endFunction !=undefined)
                            endFunction(loyaltyCard);
                    },
                    function (data) {   //failure
                        //error handling goes here
                        //TODO
                    });
        };

        LoyaltyCardItem.prototype.getLoyaltyCard = function()
        {
            return this.loyaltyCard;
        };

        LoyaltyCardItem.prototype.getItem = function()
        {
            return this.loyaltyCard;
        };

        LoyaltyCardItem.prototype.getItemCategoryType = function()
        {
            return LoyaltyCardCategory;
        };

        LoyaltyCardItem.prototype.getItemType = function()
        {
            return LoyaltyCard;
        };

        LoyaltyCardItem.prototype.getDiscountPrice = function(taxMode)
        {
            var price = 0;
            if (this.sale.isStatusSoldOrCreditOrCanceled()) {
                price = this.price;
                //apply global discount on price
                if (this.sale.discountPercent != 0) {
                    price -= this.sale.discountPercent * price / 100;
                }

                if(taxMode === TaxMode.HT){
                    var vat = this.vat?this.vat:this.sale.vat;
                    price = price / (100 + vat) * 100;
                }
            }

            return price;
        };

        return LoyaltyCardItem;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardItemSrv',["$log","LoyaltyCardItem_Resource","LoyaltyCardItem","UserActionData","LoyaltyCardItemData","ServerSrv","SaleData",
        function ($log,LoyaltyCardItem_Resource,LoyaltyCardItem,UserActionData,LoyaltyCardItemData,ServerSrv,SaleData)
    {
        var  loyaltyCardSrv =
        {};
        loyaltyCardSrv.save =  function(loyaltyCard,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(loyaltyCardSrv.saveSync, loyaltyCard, successFunction, errorFunction);
        };
        loyaltyCardSrv.saveSync = function(loyaltyCard,successFunction,errorFunction)
        {
            //$timeout (function () {

            var LoyaltyCardItemRes = loyaltyCard.getObjectResource();
            LoyaltyCardItemRes.$save({}, //no params
                function (data) {
                    try{
                        if(loyaltyCard.id == null) {
                            loyaltyCard.id = data.id;
                        }
                        if (!loyaltyCard.version || (data.version && data.version > loyaltyCard.version))
                            loyaltyCard.version = data.version;
                        /** @namespace data.supplierId */
                        if (data.supplierId && loyaltyCard.supplier)
                            loyaltyCard.supplier.id = data.supplierId;

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        loyaltyCardSrv.remove =  function(loyaltyCard,successFunction,errorFunction)
        {
            LoyaltyCardItemData.remove(loyaltyCard);
            ServerSrv.startSavingProcess(loyaltyCardSrv.removeSync, loyaltyCard, successFunction, errorFunction);
        };
        loyaltyCardSrv.removeSync =  function(loyaltyCard,successFunction,errorFunction)
        {
            //$timeout (function () {

            var loyaltyCardRes = new LoyaltyCardItem_Resource();
            loyaltyCardRes.$remove({id:loyaltyCard.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        loyaltyCardSrv.restore =  function(loyaltyCard,successFunction,errorFunction)
        {
            LoyaltyCardItemData.restore(loyaltyCard);
            ServerSrv.startSavingProcess(loyaltyCardSrv.restoreSync, loyaltyCard, successFunction, errorFunction);
        };
        loyaltyCardSrv.restoreSync =  function(loyaltyCard,successFunction,errorFunction)
        {
            //$timeout (function () {

            var loyaltyCardRes = loyaltyCard.getObjectResource();
            loyaltyCardRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        loyaltyCardSrv.query = function(successFunction,errorFunction)
        {
            LoyaltyCardItem_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    LoyaltyCardItemData.deletedLoyaltyCardItems = [] ;
                    for (var i=0;i< data.length;i++)
                        new LoyaltyCardItem(data[i]);//Auto Add to LoyaltyCardItemData

                    if (successFunction!== undefined )
                        successFunction(LoyaltyCardItemData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("LoyaltyCardItem_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        }
        loyaltyCardSrv.loadRef =  function(isApplicationLoading)
        {
            var loyaltyCards = LoyaltyCardItemData.indexLoyaltyCardItems;
            for (var i=0;i<loyaltyCards.length;i++)
                loyaltyCards[i].loadRef(null, isApplicationLoading);

        }
        loyaltyCardSrv.updateLocally =  function(id,resource)
        {
            var loyaltyCardItem = LoyaltyCardItemData.getById(id);
            if (loyaltyCardItem!=null)
            {
                loyaltyCardItem.loadObject(resource);
                loyaltyCardItem.id = id;
                loyaltyCardItem.loadRef();
                //remove from sale
                if(loyaltyCardItem.sale)
                    loyaltyCardItem.sale.removeLoyaltyCardItem(loyaltyCardItem);
                if(resource.saleId)
                {
                    var sale = SaleData.getById(resource.saleId);
                    if (sale)
                        sale.addLoyaltyCardItem(loyaltyCardItem);
                }
            }
            return loyaltyCardItem
        };
        loyaltyCardSrv.addLocally =  function(id,resource)
        {
            var loyaltyCardItem = LoyaltyCardItemData.getById(id);
            if (loyaltyCardItem!=null)
                loyaltyCardItem.loadObject(resource);
            else
            {
                loyaltyCardItem = new LoyaltyCardItem(resource,null,false);
            }
            loyaltyCardItem.id = id;
            loyaltyCardItem.loadRef();
            if(resource.saleId)
            {
                var sale = SaleData.getById(resource.saleId);
                if (sale)
                    sale.addLoyaltyCardItem(loyaltyCardItem);
            }
            return loyaltyCardItem;
        };
        loyaltyCardSrv.removeLocally =  function(id,resource)
        {
            var loyaltyCardItem = LoyaltyCardItemData.getById(id);
            if (loyaltyCardItem!=null)
            {
                //remove from sale
                if(loyaltyCardItem.sale)
                    loyaltyCardItem.sale.removeLoyaltyCardItem(loyaltyCardItem);
            }
            return loyaltyCardItem;
        };

        return loyaltyCardSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardItemData',["$log", function ($log)
    {
        var  loyaltyCardData =
        {
            indexLoyaltyCardItems : [], //Used as Index
            deletedLoyaltyCardItems : []
        };
        loyaltyCardData.getById =  function(loyaltyCardId)
        {
            for (var i=0;i<this.indexLoyaltyCardItems.length;i++)
                if (this.indexLoyaltyCardItems[i].id==loyaltyCardId)
                    return this.indexLoyaltyCardItems[i];
            return null;
        }
        loyaltyCardData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexLoyaltyCardItems.length)
            {
                return this.indexLoyaltyCardItems[servIndex];
            }
            else
                return null;
        }
        loyaltyCardData.getIndexOf =  function(loyaltyCard)
        {
            if (loyaltyCard)
                return this.indexLoyaltyCardItems.indexOf(loyaltyCard);
            return -1;
        }
        loyaltyCardData.add =  function(loyaltyCard)
        {
            this.indexLoyaltyCardItems.push(loyaltyCard);
            if (loyaltyCard.isDeleted)
            {
                var index = this.deletedLoyaltyCardItems.indexOf(loyaltyCard)
                if (index==-1)
                    this.deletedLoyaltyCardItems.push(loyaltyCard);
            }
            return this.indexLoyaltyCardItems.length-1;
        }
        loyaltyCardData.remove =  function(loyaltyCard) //Soft Remove
        {
            var index =  this.deletedLoyaltyCardItems.indexOf(loyaltyCard);
            if (index==-1)
            {
                this.deletedLoyaltyCardItems.push(loyaltyCard)
                loyaltyCard.isDeleted=true;
            }

        }
        loyaltyCardData.restore =  function(loyaltyCard) //Soft Remove
        {
            var index =  this.deletedLoyaltyCardItems.indexOf(loyaltyCard);
            if (index!=-1)
            {
                this.deletedLoyaltyCardItems.splice(index,1)
                loyaltyCard.isDeleted=false;
            }

        }
        loyaltyCardData.clear =  function()
        {
            loyaltyCardData.indexLoyaltyCardItems = [];
            loyaltyCardData.deletedLoyaltyCardItems = [];
        }
        loyaltyCardData.getDeletedList =  function()
        {
            return loyaltyCardData.deletedLoyaltyCardItems;
        }

        return loyaltyCardData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/LoyaltyCardItem.js